import { useContext } from 'react'

import { HeadersContext } from '../../../HeadersContext'
import { usePageProps } from '../../../usePageProps'
import { getUserFreeMembership } from '../../../utils/get-user-session-permissions'

export const useShouldShowFreeMembershipBenefitsPanel = (): boolean => {
  const { userAccessState } = usePageProps()
  const { cookies } = useContext(HeadersContext)
  const isFreeMembership = getUserFreeMembership(cookies ?? '')

  return userAccessState?.userLoggedIn === true && isFreeMembership
}
